export enum RecorderErrorCodes {
    IDENTIFYING_HOLTER_FAILED = 'IDENTIFYING_HOLTER_FAILED',
}
